import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=c3bf60d4&scoped=true"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=c3bf60d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bf60d4",
  null
  
)

export default component.exports